export default "__VITE_ASSET__CBk3sQZF__";